// extracted by mini-css-extract-plugin
export var shadowDark = "shadow-border-module--shadowDark--1Fzz1";
export var shadowLight = "shadow-border-module--shadowLight--14k_-";